import React from 'react';
import styled from "styled-components";
import {CalculateDiff} from "../../Utils/Dates";
import moment from "moment";

const CustomerItem=styled.div`
display:grid;
grid-template-columns: 1fr 1fr;`;

const Text=styled.p`
text-align:center;
margin:10px 0;
`;

export default class CustomerItemGrid extends React.Component
{
    state=
    {
        diff:undefined
    }

    tick=()=>
    {
        var date = this.props.date.toString();
        var dateString=date.toString();
        var diffSeconds=CalculateDiff(dateString);
        var diff=moment().startOf('day').millisecond(diffSeconds).format('H:mm');
        this.setState({diff:diff});
    }

    componentDidMount()
    {
        this.tick();
        setInterval(() =>
        {
            this.tick();
        }, 3000)
    }
    
   render()
   {
    var currentUser= this.props.name===this.props.currentUser.name && this.props.dinersCount===this.props.currentUser.dinersCount;
    var BGColor="initial";
    var Weight="initial";
    var Size="initial";
    
    if(currentUser===true)
    {   
        BGColor="black";
        Weight="bold";
        Size="20px";
    }

    return <CustomerItem style={{border:`1px solid ${BGColor}`,fontWeight:Weight,fontSize:Size}}>
    <Text>{currentUser ? this.props.name : String(this.props.name)[0]}       </Text>
    <Text>{this.props.dinersCount}</Text>
    </CustomerItem>
   }
  
}
